<template>
  <div class="filter">
    <div class="filter_form">
      <div class="level bottom">
        <div class="level-left"></div>
        <div class="level-right filter_actions" v-if="userRole !== 'user'">
          <button
            class="delete_course"
            @click="$emit('delete')"
            v-if="!search.archive"
            :disabled="!rows.checked.length"
          >
            <i class="mdi mdi-folder-remove-outline"></i> Удалить
          </button>
          <button class="add_course" @click="$emit('open-modal')">
            <i class="mdi mdi-folder-plus-outline"></i> Загрузить файлы
          </button>
        </div>
      </div>
      <form class="level" @submit.prevent="$emit('submit')">
        <b-field label="Поиск по базе знаний:" class="branch_search input_search with_button" type="is-info">
          <b-input placeholder="Поиск по базе знаний" v-model="search.name"></b-input>
          <button type="submit">Поиск</button>
        </b-field>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    search: {
      default: () => {},
      type: Object
    },
    rows: {
      default: () => {},
      type: Object
    }
  },
  computed: {
    userRole() {
      return this.$store.state.auth.role[0]
    }
  }
}
</script>
